<template>
  <div>
    <withdrawal-card class="mb-4" :withdrawal="withdrawal" />
    <withdrawal-status-list :statuses="withdrawal.statuses" />
  </div>
</template>

<script>
import WithdrawalCard from '@core/components/withdrawal/WithdrawalCard'
import WithdrawalStatusList from '@core/components/withdrawal/WithdrawalStatusList'

export default {
  name: 'WithdrawalPanel',
  components: { WithdrawalStatusList, WithdrawalCard },
  props: {
      withdrawal: {
          type: Object,
          required: true
      }
  }
}
</script>
